import React from 'react';
import '../../App.css';
import CloseIcon from "mdi-react/CloseCircleOutlineIcon"
import Popup from 'reactjs-popup';
import {
    EmailShareButton,
    FacebookShareButton,
    //LinkedinShareButton,
    RedditShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    FacebookIcon,
    EmailIcon,
    //LinkedinIcon,
    RedditIcon,
    TwitterIcon,
    WhatsappIcon,
 } from "react-share";
import ButtonLoader from './ButtonLoader';
import ContentCopyIcon from 'mdi-react/ContentCopyIcon';
import Colors from '../Colors';

class ShareModal extends React.Component {

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand('copy');
        e.target.focus();
      };

    render() {
        var shareText = this.props.text
        //var shareImage = this.props.image
        var shareCategory = this.props.hashtag
        var shareUrl = this.props.url

         return (
         <Popup
            open={this.props.active} 
            onClose={this.props.onClose}
            closeOnDocumentClick
            contentStyle={{minWidth:300, borderRadius:10}}
            ref={o => this.popupRef = o }
            //modal
            >
            <div style={{margin:"30px 30px", display: "flex", flexDirection:"column"}}>
            <CloseIcon className={"button-hover"} size={30} onClick={() => this.popupRef.close()} style={{ alignSelf:"flex-end"}}></CloseIcon>
               <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20}}>
               <h2>{this.props.title}</h2>
                  
               </div>
               <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", flexWrap:"wrap" }}>
                  <EmailShareButton
                     className="reversed-button-hover"
                     subject={shareText}
                     body={shareUrl}>
                     <EmailIcon round size={46}></EmailIcon>
                  </EmailShareButton>
                  <FacebookShareButton
                     className="reversed-button-hover"
                     url={shareUrl}
                     quote={shareText}
                     hashtag={"#" + shareCategory}
                     >
                     <FacebookIcon round size={46}></FacebookIcon>
                  </FacebookShareButton>
                  <TwitterShareButton
                     className="reversed-button-hover"
                     url={shareUrl}
                     title={shareText}
                     hashtag={"#" + shareCategory}
                  //className={classes.socialMediaButton}
                  >
                     <TwitterIcon round size={46} />
                  </TwitterShareButton>
                  <WhatsappShareButton
                     className="reversed-button-hover"
                     url={shareUrl}
                     title={shareText}
                     separator=":: "
                  //className={classes.socialMediaButton}
                  >
                     <WhatsappIcon round size={46} />
                  </WhatsappShareButton>
                  <RedditShareButton 
                     className="reversed-button-hover"
                     title={shareText} 
                     url={shareUrl}>
                     <RedditIcon round size={46}></RedditIcon>
                  </RedditShareButton>
               </div>
               <h5 style={{margin: 10, color:"#ccc" }}>copy link</h5>
               <div style={{display:"flex", flexDirection:"row", justifyContent:"space-around", marginBottom:30, alignItems:"center", flexWrap:"wrap" }}>
                  <input ref={(textarea) => this.textArea = textarea} type="text" defaultValue={shareUrl} name="text" className="simple-input" style={{minWidth:"65%", marginRight:10, outline:"none"}}></input>
                  <ButtonLoader
                     //text="Copy link" 
                     style={{ backgroundColor: Colors.softText, height: 50, marginLeft: 5, }}
                     icon={ContentCopyIcon}
                     onClick={this.copyToClipboard}
                  ></ButtonLoader>

               </div>
               
            </div>
         </Popup>
      )
    }
}

export default ShareModal